// extracted by mini-css-extract-plugin
export default {"image_bibliotheque":"liste-image_image_bibliotheque__ptEbC","aucune_image_bibliotheque":"liste-image_aucune_image_bibliotheque__stEsS"};